/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM, TOP } from 'Component/ChevronIcon/ChevronIcon.config';
import ClickOutside from 'Component/ClickOutside';
import { StoreSwitcher as SourceStoreSwitcher } from 'SourceComponent/StoreSwitcher/StoreSwitcher.component';

import './StoreSwitcher.style';

/** @namespace Pwa/Component/StoreSwitcher/Component */
export class StoreSwitcher extends SourceStoreSwitcher {
    renderDesktopStoreSwitcher() {
        const {
            storeList,
            onStoreSwitcherOutsideClick,
            onStoreSwitcherClick,
            isOpened,
            currentStoreCode
        } = this.props;

        const lang = currentStoreCode ?? 'PL';
        const onlyOne = storeList?.length === 1;

        const mods = { isOpen: isOpened, onlyOne };

        return (
            <div block="StoreSwitcher">
                <ClickOutside onClick={ onStoreSwitcherOutsideClick }>
                    <button
                      block="StoreSwitcher"
                      elem="Title"
                      mods={ mods }
                      onClick={ onlyOne ? () => null : onStoreSwitcherClick }
                    >
                        <div
                          block="StoreItem"
                          elem={ `Lang${lang.toUpperCase()}` }
                        />
                        { !onlyOne && (
                            <ChevronIcon direction={ isOpened ? TOP : BOTTOM } />
                        ) }
                    </button>

                    <div block="StoreSwitcher" elem="StoreList" mods={ mods }>
                        <span>{ storeList.map(this.renderStore) }</span>
                    </div>
                </ClickOutside>
            </div>
        );
    }

    render() {
        const { storeList, device } = this.props;

        if (storeList.length <= 0) {
            return null;
        }

        if (device.isMobile) {
            return this.renderMobileStoreSwitcher();
        }

        return this.renderDesktopStoreSwitcher();
    }
}

export default StoreSwitcher;
